// En qué taller trabaja **esta pestaña** (#205), para quien no es un componente.
//
// Lo lee `api.ts` para poner la cabecera `X-Tenant-Id` en cada petición, y lo
// escribe `ProveedorTaller` cuando elige. Vive fuera de React por lo mismo que el
// gestor de la sesión: las peticiones salen también fuera de un dibujado, y tiene
// que haber una sola fuente.
//
// **Es de la pestaña, no del navegador.** Una persona puede tener una pestaña en
// el Taller López y otra en el Morales, y cada una manda el suyo. La API acepta
// cualquiera de los dos porque los dos vienen firmados en su token; lo que no
// acepta es uno que no esté ahí.

let actual: string | undefined;

/** El id del taller elegido, o `undefined` si todavía no se eligió ninguno. */
export function tallerActivo(): string | undefined {
  return actual;
}

/** Lo llama solo `ProveedorTaller`. */
export function fijarTallerActivo(id: string | undefined) {
  actual = id;
}
